import Icon from 'veui/components/Icon'
import { IconVideoHistory } from 'dls-icons-vue'

Icon.register('video-history', IconVideoHistory)
